export function tabs() {
  const tabs = $(".tabs");
  let navTab = $(".tab-link");
  let _href;
  let tabsPos;
  if(window.location.hash.length) {
    _href = window.location.hash;
    tabsPos = tabs.offset().top;
    changeTab(_href);
  }

  navTab.on("click", function() {
    tabs.addClass("change");
    setTimeout(() => {
      _href = window.location.hash;
      changeTab(_href);
    });
  });
  
  function changeTab(locy) {
    tabsPos = tabs.offset().top;
    $(`[href="${locy}"]`).parents(".tab-nav-item").addClass("active").siblings(".tab-nav-item").removeClass("active");
    $(`${locy}`).addClass("active").siblings(".tab-content-item").removeClass("active");
    $("html, body").animate({
      scrollTop: tabsPos
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js